import styles from './index.module.css'
import { FC } from 'react'
import {SwitchButton} from '../switchButton/switchButton.tsx'

interface OpenButtonProps {
  onClickButton?: () => void;
}

export const OpenButton: FC<OpenButtonProps> = ({ onClickButton }) => {
  return (
    <div className={styles.clock}>
      <span className={styles.switch_text}>PROJECTS</span>
     <SwitchButton text='some' variant='sled' onClickButton={onClickButton} />
    </div>
  )
}



